(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["consent-gate"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function gatedScripts() {
      return document.querySelectorAll('script[data-consent-category][data-src]');
    }

    function activateScript(el) {
      if (el.dataset.consentActivated === 'true') return; // idempotent -- see doc comment
      el.dataset.consentActivated = 'true';

      var fresh = document.createElement('script');
      for (var i = 0; i < el.attributes.length; i++) {
        var attr = el.attributes[i];
        if (
          attr.name === 'type' ||
          attr.name === 'data-src' ||
          attr.name === 'data-consent-category' ||
          attr.name === 'data-consent-activated'
        ) {
          continue; // gating-only attributes -- everything else (crossorigin, a nonce, ...) carries over
        }
        fresh.setAttribute(attr.name, attr.value);
      }
      fresh.src = el.dataset.src;
      el.parentNode.insertBefore(fresh, el.nextSibling);
    }

    function activateCategory(category) {
      gatedScripts().forEach(function (el) {
        if (el.dataset.consentCategory === category) activateScript(el);
      });
    }

    // '' (unanswered) and 'no' both mean "don't load" -- only an explicit 'yes' activates.
    function isGranted(consent, category) {
      return !!consent && consent[category] === 'yes';
    }

    function checkInitialConsent() {
      try {
        var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        ['marketing', 'analytics', 'preferences', 'sale_of_data'].forEach(function (category) {
          if (isGranted(consent, category)) activateCategory(category);
        });
      } catch (err) {
        // Fail closed: swallow and do nothing -- gated scripts stay gated.
      }
    }

    // Attached unconditionally, before Shopify.loadFeatures is even called --
    // see doc comment on why this listener can't wait on loadFeatures resolving.
    document.addEventListener('visitorConsentCollected', function (event) {
      var detail = (event && event.detail) || {};
      if (detail.marketingAllowed) activateCategory('marketing');
      if (detail.analyticsAllowed) activateCategory('analytics');
      if (detail.preferencesAllowed) activateCategory('preferences');
      if (detail.saleOfDataAllowed) activateCategory('sale_of_data');
    });

    if (gatedScripts().length === 0) return; // nothing on this page needs the API at all

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      return; // fail closed -- no API surface, never activate
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return; // fail closed -- do NOT fall through to loading gated scripts
        checkInitialConsent();
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
